import { EstimateType, NOTE_TYPE_TO_ESTIMATE_TYPE, NoteType } from "@rebuild/shared";

export { NoteType };

/** Lowercase for Custom Reese Firestore storage (backward compatibility) */
export function toStorageNoteType(noteType: NoteType | string): string {
	return (noteType || "").toLowerCase();
}

/** Map stored lowercase to NoteType for display when loading existing prompts */
export function fromStorageNoteType(stored: string): NoteType {
	const map: Record<string, NoteType> = {
		mitigation: NoteType.MITIGATION,
		"interior reconstruction": NoteType.INTERIOR_RECONSTRUCTION,
		"exterior reconstruction": NoteType.EXTERIOR_RECONSTRUCTION,
		contents: NoteType.CONTENTS,
		mold: NoteType.MOLD,
		"fire mitigation": NoteType.FIRE_MITIGATION,
		biohazard: NoteType.BIOHAZARD,
		"time and material": NoteType.TIME_AND_MATERIAL,
	};
	return map[stored.toLowerCase()] ?? NoteType.MITIGATION;
}

/**
 * Gets the display name for a NoteType (values are already display-ready)
 */
export function getNoteTypeDisplayName(noteType: NoteType | string): string {
	return noteType || "";
}

/** NoteTypes that require noteType filter when fetching by estimateType */
export const RECONSTRUCTION_NOTE_TYPES: NoteType[] = [
	NoteType.INTERIOR_RECONSTRUCTION,
	NoteType.EXTERIOR_RECONSTRUCTION,
];

export function isReconstructionNoteType(noteType: NoteType): boolean {
	return RECONSTRUCTION_NOTE_TYPES.includes(noteType);
}

/** Maps NoteType to EstimateType for API fetch by estimate */
export function getEstimateTypeForNoteType(noteType: NoteType): EstimateType {
	return NOTE_TYPE_TO_ESTIMATE_TYPE[noteType] ?? EstimateType.MITIGATION;
}
